


import { Vue, Component } from "vue-property-decorator";

import Ocean from "Web/Components/Common/Ocean.vue";

@Component({
    components: {
        Ocean
    }
})
export default class User extends Vue {
}
